/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class GroupRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let templateSet = this.modelFor('people.schema.template');
    return hash({
      templateSet,
      group: this.store.findRecord('people-schema/group', params.group_id),
      fields: this.store.query('people-schema/field', {
        groupId: params.group_id,
        setId: templateSet.id,
      }),
    });
  }
}
